/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'virtual-service';
const componentName = 'virtual-host-grid';
const prefix = `${moduleName}.${componentName}`;

export const hostsLabel = `${prefix}.hostsLabel`;
export const virtualHostingMatchLabel = `${prefix}.virtualHostingMatchLabel`;

export const ENGLISH = {
    [hostsLabel]: 'Hosts ({0})',
    [virtualHostingMatchLabel]: 'Virtual Hosting Match',
};
